<template>
  <div class="duty" :class="computer ? 'duty-pc' : ''">
    <header class="ant-layout-header">
      <div class="left">
        BOBO公式
      </div>
      <div class="right"></div>
    </header>

    <div class="duty-wrapper">
      <div class="title1">使用条款</div>
      <div class="title2">免责声明：</div>
      <p class="paragraph">
        BOBO公式只是一个工具，以帮助眼科医生为患者选择合适的人工晶体度数而产生。由此计算器得到的结果并不打算作为临床的指导，眼科医生必须对患者的正确治疗做出自己的独立决定，并对术后屈光结果单独负责。通过使用此工具得出的结果，您同意放弃并使作者免受任何索赔。
        此计算工具不存储病人或眼科医生的数据或个别计算的细节。
        BOBO公式是基于陈波医生的知识产权。它仅用于教育和临床目的。本协议不给予用户BOBO公式或任何适用的商业秘密、知识产权、专利、商标或版权中的所有权。通过点击下面的“我同意”，用户将受到本协议条款的约束。
        请记住，这个计算器和它所使用的方法，在很多方面，都是实验性的。请您使用不同的公式反复检查你的计算结果的准确性。
      </p>
      <div class="title1">Terms of Use</div>
      <div class="title2">DISCLAIMER：</div>
      <p class="paragraph">
        The BOBO Formula is a tool to assist physicians in selecting the appropriate IOL for their
        patients. The results obtained by the calculator are not intended to serve as instruction
        from the author. Surgeons must arrive at their own independent determination regarding the
        proper treatment for their patients and are solely responsible for the refractive outcome.
        By using the BOBO formula, you agree to waive and hold the author harmless from any claims
        you may have arising out of your use of this tool. This tool not store patient or surgeon
        data or details of individual calculations. Patient or surgeon identifiers are not
        accessible to the service provider at any time. The BOBO formula is based on the
        intellectual property of Dr. BO CHEN. It is provided for educational and clinical purposes
        only. This agreement gives the user no ownership right, title or interest in the BOBO
        Formula or in any applicable trade secrets, intellectual property rights, patents,
        trademarks or copyrights. By clicking “I agree” below the user will be bound by the terms of
        this agreement. Remember that this calculator and the methods that it uses are, by many
        ways, experimental. ALWAYS DOUBLE-CHECK YOUR CALCULATIONS USING DIFFERENT FORMULAS.
      </p>
      <div class="button-wrapper">
        <a-button type="primary" @click="handleIAgree">我同意(Agree)</a-button>
      </div>
    </div>
    <div class="thanks">
      <a-divider></a-divider>
      致谢在我开发此公式期间给予我数据提供和数据收集的以下同事和同行们：
      张瑞帆、吴峥峥、李嘉文、陈斌、杨平、田杰中、陈小凤、段平、徐正东、
      代艳、陈丹、田园、庞利、邹琴、刘梦瑶、罗雪松、刘治容、杨柳、张友、 罗丽、林波、叶南星等。
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted } from "vue";
import { isComputer } from "@/utils";
import { useRouter } from "vue-router";

const router = useRouter();

const handleIAgree = () => {
  router.push({
    path: "/calculate",
  });
};

const computer = isComputer();

onMounted(() => {
  document.title = "BOBO公式";
});
</script>

<style lang="less" scoped>
p {
  margin-top: 0;
  margin-bottom: 1em;
}

.ant-layout-header {
  padding: 0 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 1px;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(135deg, #35b7ad 10%, #abdcff);
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.duty-wrapper {
  padding: 0 25px 0 23px;
  .title1 {
    text-align: center;
  }
  .paragraph {
    text-indent: 2em;
  }
}

p {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  font-variant: tabular-nums;
  line-height: 1.5;
  background-color: #fff;
  font-feature-settings: "tnum";
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

.thanks {
  padding: 0 25px 0 23px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  opacity: 0.9;
}

.duty {
  height: 100vh;
  overflow-y: scroll;
}

.button-wrapper {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.duty-pc {
  h2 {
    margin-bottom: 0.05rem;
  }
  .ant-layout-header {
    height: 0.42rem;
    line-height: 0.42rem;
    font-size: 0.17rem;
    padding-left: 0.5rem;
    span {
      font-size: 0.09rem;
    }
  }
  .duty-wrapper {
    padding: 0.1rem 1.8rem 0;
    .title1 {
      font-size: 0.1rem;
      margin-top: 0.16rem;
      font-weight: 400;
      color: #333333;
    }
    .title2 {
      font-size: 0.09rem;
      margin-bottom: 0.1rem;
      font-weight: 400;
      color: #333333;
    }
    .paragraph {
      letter-spacing: 1px;
      line-height: 0.15rem;
      font-size: 0.07rem;
      color: #4c4c4c;
    }
  }
  button {
    letter-spacing: 1px;
  }
  .button-wrapper {
    margin: 0.16rem 0;
    font-size: 0.12rem;
  }
  .thanks {
    padding: 0 1.8rem;
    font-size: 0.07rem;
    line-height: 0.15rem;
    letter-spacing: 1px;
    color: #4c4c4c;
    font-weight: 400;
  }
}
</style>
